<template>
  <div
    class="node-list-carousel-slagbib-poster-slide"
    :style="{
      '--primary-poster-bg-color': primaryDominatedColor
    }"
  >
    <div
      class="node-list-carousel-slagbib-poster-slide--header"
      :style="{
        backgroundImage: `url('${ teaserImage }')`
      }"
    >
    </div>
    <div
      class="node-list-carousel-slagbib-poster-slide--content"
      :style="{
        '--primary-poster-bg-color': primaryDominatedColor,
        '--primary-poster-text-color': isSpecialColorLight ? '#1c1b1b' : '#ffffff'
      }"
    >
      <h1
        ref="title"
        class="node-list-carousel-slagbib-poster-slide--title"
        :style="{
          height: customTitleHeight
        }"
      >
        {{ truncatedTitle }}
      </h1>
      <div
        v-if="isEvent"
        class="node-list-carousel-slagbib-poster-slide--meta"
      >
        <div
          v-if="date"
          class="node-list-carousel-slagbib-poster-slide--date"
        >
          <i class="esi esi-clock"></i>
          {{ formattedDate }}
        </div>
        <div
          v-if="location"
          class="node-list-carousel-slagbib-poster-slide--location"
        >
          <i class="esi esi-map-marker"></i>
          {{ location }}
        </div>
      </div>
    </div>

    <div
      :class="['node-list-carousel-slagbib-poster-slide--footer', {
        'node-list-carousel-slagbib-poster-slide--footer-without-qr-code': qrCode == null || qrCode === ''
      }]"
      :style="{
        '--primary-poster-bg-color': primaryDominatedColor,
        '--primary-poster-text-color': isSpecialColorLight ? '#1c1b1b' : '#ffffff'
      }">
      <div v-if="qrCode" class="node-list-carousel-slagbib-poster-slide--footer-read-more">
        <span>{{ _l10n("Read more (poster-slide)").split(" ")[0] }}</span>
        <span>{{ _l10n("Read more (poster-slide)").split(" ")[1] }}</span>
      </div>

      <div v-if="qrCode" class="node-list-carousel-slagbib-poster-slide--footer-qr-code-wrapper">
        <div
          class="node-list-carousel-slagbib-poster-slide--footer-qr-code"
          :style="{ backgroundImage: `url('${ $easyscreenRequest.lmsConnector.wrapCover(qrCode) }')` }"
        ></div>
      </div>

      <div class="node-list-carousel-slagbib-poster-slide--footer-location">
        <span>{{ $easyscreenConfig.name.split(" ")[0] }}</span>
        <span>{{ $easyscreenConfig.name.split(" ")[1] }}</span>
      </div>
    </div>
  </div>
</template>

<style src="../../core/ck-editor.less" lang="less"></style>
<style src="../../core/icons.less" lang="less"></style>
<style src="./node-list-carousel-slagbib-poster-slide.less" lang="less"></style>

<script>
  import moment from "moment";

  import htmlElementHeight from "@/lib/utils/html-element-height.js";
  import l10n from "@/lib/localization/localization.js";
  import orientationMixin from "../../core/mixins/orientation.js";
  import cutText from "@/lib/utils/cut-text.js";

  import getDominantImageColor from "../../../lib/utils/get-dominant-image-color";
  import ColorMixer from "color-mixer";

  export default {
    name: "node-list-carousel-slagbib-poster-slide",
    mixins: [orientationMixin],
    props: {
      type: String,
      date: String,
      dateTo: String,
      location: String,
      price: [String, Number],
      bgImage: String,
      image: String,
      title: String,
      esTeaser: String,
      teaser: String,
      text: String,
      lead: String,
      qrCode: String
    },
    computed: {
      isEvent() {
        return this.type === "event";
      },
      backgroundImage: {
        get() {
          return this.bgImage || this.image;
        }
      },
      momentDate() {
        const dateFrom = moment(this.date);
        const dateTo = moment(this.dateTo);
        let date = moment();

        if (date < dateFrom) {
          date = dateFrom;
        } else if (date > dateTo) {
          date = dateTo;
        }

        date.hour(dateFrom.hour());
        date.minute(dateFrom.minute());

        return date;
      },
      formattedDate: {
        get() {
          const date = this.momentDate;

          let formattedDate = date.format("D. MMMM");
          if (this.layout === "welcome-screen") {
            formattedDate = date.format("DD.MM.YYYY");
          }

          const timeFrom = date.format("HH.mm");
          const timeTo = moment(this.dateTo).format("HH.mm");

          if (timeFrom !== "00.00") {
            formattedDate += ` ${ l10n("Kl.") } ${ timeFrom }`;
            if (timeFrom !== timeTo) {
              formattedDate += ` - ${ timeTo }`;
            }
          }

          return formattedDate;
        }
      },
      teaserImage() {
        return this.image || this.bgImage;
      },
      truncatedTitle() {
        return cutText(this.title, 40);
      },
      isSpecialColorLight() {
        const hslColor = new ColorMixer.Color({ hex: this.primaryDominatedColor }).hsl();
        if (hslColor[2] > 60) {
          return true;
        }

        return false;
      }
    },
    data() {
      return {
        defaultTitleHeight: null,
        customTitleHeight: null,
        primaryDominatedColor: "",
        secondaryDominatedColor: ""
      };
    },
    methods: {
      _l10n: l10n,
      getDefaultTitleHeight() {
        if (this.defaultTitleHeight === null && this.$refs.title) {
          this.defaultTitleHeight = htmlElementHeight(this.$refs.title);
        }

        return this.defaultTitleHeight || 0;
      },
      setTitleHeight(height) {
        this.customTitleHeight = height;
      },
      _resetCustomTitleHeight() {
        this.customTitleHeight = null;
        this.defaultTitleHeight = null;
      }
    },
    async mounted() {
      this.$on("before-orientation-change", this._resetCustomTitleHeight);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = this.$easyscreenRequest.lmsConnector.wrapCover(this.teaserImage);
      try {
        this.primaryDominatedColor = await getDominantImageColor(img);
      } catch (err) {
        console.error("Can't get dominant color for image!", err);
      }
    },
    beforeDestroy() {
      this.$off("before-orientation-change", this._resetCustomTitleHeight);
    }
  };
</script>
